/* globals confirm, console, module, require, window */
/* jshint esversion:6, globalstrict:true */
'use strict';

const jQuery = require('jquery'),
    Marionette = require('backbone.marionette'),
    _ = require('lodash'),
    //
    Unit = require('../models/unit'),
    Units = require('../collections/units'),
    // Create = require('./create'),
    templates = require('../utilities/handlebars').templates,
    UnitsList = require('./unitsList'),
    EOL = null;

module.exports = Marionette.View.extend({
    attributes: {
        id: 'units',
        name: 'units',
        class: 'units section'
    },
    childViewEvents: {
        //
        'edit:end': function (options) {this.trigger('edit:end', options);},
        'edit:inProgress': function (options) {this.trigger('edit:inProgress', options);},
        'edit:start': function (options) {this.trigger('edit:start', options);},
        'vacancy:countChanged': function (options) {this.trigger('vacancy:countChanged', options);}
    },
    events: {
        'click button': 'onClickButton'
    },
    regions: {
        unitsList: {el: 'div[name=unitsList]', replaceElement: true}
    },
    tagName: 'div',
    template: templates.unitsSection,
    //
    initialize: function () {
        this.units = new Units([], {programId: this.options.programId});
        this.templateContext = {
            hasAdminAccess: this.options.hasAdminAccess
        };
    },
    onClickButton: function (event) {
        switch (event.currentTarget.dataset.action) {
            case 'add':
                this.units.add(new Unit());
                break;
            default:
                break;
        }
        return false;
    },
    onRender: function () {
        this.showChildView('unitsList', new UnitsList({collection: this.units, programId: this.options.programId, hasAdminAccess: this.options.hasAdminAccess}));
        return this;
    }
});
